import Model from './Model';

export default class Customer extends Model {
  initializeFields() {
    this.brand = this.data.brand ? this.data.brand.trim() : '';
    this.customer = this.data.customer ? this.data.customer.trim() : '';
    this.parent_ref = this.data.parent_ref ? this.data.parent_ref.trim() : '';
    this.ref = this.data.ref ? this.data.ref.trim() : '';
  }
}
